export function groupMatchesByCompetition<T extends { competition: string }>(matches: T[]) {
  return matches.reduce<Record<string, T[]>>((groups, match) => {
    (groups[match.competition] ??= []).push(match);
    return groups;
  }, {});
}
